import { z } from "zod";

export const userSchema = z.object({
  id: z.number(),
  name: z.string().optional().nullable(),
  username: z.string(),
  email: z.string().email().optional().nullable(),
  status: z.boolean(),
  roles: z.object({
    name: z.string(),
  }),
  availableRoles: z.array(z.string()),
  password: z.string().optional().nullable(),
  // relation_id: z.number(),
});

export type UserModel = z.infer<typeof userSchema>;

export const userColumns = [
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "email",
    header: "Email",
  },
];
